import { EmploymentPlan } from './employment-plan.model';

export class Components {
  constructor(
    public id?: number,
    public createdBy?: string,
    public createdDt?: any,
    public lastModifiedBy?: string,
    public lastModifiedDt?: any,
    public componentCd?: string,
    public serviceProviderName?: string,
    public startDt?: any,
    public estimatedCompletionDt?: any,
    public statusCd?: string,
    public program?: string,
    public authorizedHours?: any,
    public countableHours?: any,
    public statusDt?: any,
    public notes?: string,
    public deleteSw?: string,
    public recordVersion?: number,
    public employmentPlan?: EmploymentPlan,
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/component.model.ts